﻿export interface INewFileUploads {
    centerId: number,
    recipientAgreement: File;
    recipientAgreement_Date: string;
    recipientAgreement_DocumentsVersionId: number;
    donorAgreement: File;
    donorAgreement_Date: string;
    donorAgreement_DocumentsVersionId: number;
    contract: File;
    contract_Date: string;
    contract_DocumentsVersionId: number;
    allInAgreement: File;
    allInAgreement_Date: string;
    allInAgreement_DocumentsVersionId: number;
    donorProtection: File;
    donorProtection_Date: string;
    donorProtection_DocumentsVersionId: number;
    baa: File;
    baa_Date: string;
    baa_DocumentsVersionId: number;
    partnerCenter: File;
    partnerCenter_Date: string;
    partnerCenter_DocumentsVersionId: number;
    dcn: File;
    dcn_Date: string;
    dcn_DocumentsVersionId: number;
    donorShield: File;
    donorShield_Date: string;
    donorShield_DocumentsVersionId: number;
}
